export default {
      id: "bulle_zoom-usage",
      viewBox: "0 0 645 620",
      url: "../dist/images/" + "sprite.svg#bulle_zoom-usage",
      toString: function () {
        return this.url;
      }
    }